import React from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { InputField, useFormContext } from 'clayco-controls';
import Resizer from "react-image-file-resizer";
import { isPngFile, isHeicFile, isGifFile, isPdfFile, isNotCertificationFileType } from 'constants/conditions';
import { log } from 'utils/logging';
import {alert} from 'react-bootstrap-confirmation';
import CertificationUploadField from './certificationUploadField';

const CertificateField = ({certification, index, allowNameEdit}) => {
    const [checkedState, setChecked] = useState(false);
    const [checkedAndExpiresState, setCheckedAndExpires] = useState(false);
    const {setValue, getValues } = useFormContext();
    const {t} = useTranslation();

    const name = certification?.name;
    const label = certification?.label;

    const onChange = (checked, id) =>{
        setChecked(checked);
        setCheckedAndExpires(checked && certification.expires);
        setValue(`certification.${index}.checked`, checked);
        setValue(`certification.${index}.checkedAndExpires`, (checked && certification.expires));
        if(checked)
            setValue(`certification.${index}.fileList`, null);
    };

    const handleUpload = (e)=>{
        var expiration = getValues(`certification.${index}.expiration`);
        var name = getValues(`certification.${index}.name`)

        const baseCertificationValue = {
            id: certification.id,
            checked: checkedState,
            label: certification.label,
            name: name,
            expiration: expiration,
            checkedAndExpires: checkedAndExpiresState
        };

        const setCertificationValue = (fileList, fileData) => {
            const certObj = {
                ...baseCertificationValue,
                fileList: fileList,
                fileData: fileData
            };
            setValue(`certification.${index}`, certObj);
        }

        if (e.target.files.length === 0) {
            setCertificationValue([], null);
            return;
        }

        const uploadFile = e.target.files[0]
        log.trace('handleUpload', 'uploadFile', uploadFile);
    
        if (isNotCertificationFileType(uploadFile)) {
          alert(t('InvalidFileFormat'));
          setValue(`certification.${index}.fileList`, null);
          setCertificationValue([], null);
          return;
        }
    
        if (isPngFile(uploadFile) || isGifFile(uploadFile) || isPdfFile(uploadFile) || isHeicFile(uploadFile)) {
            setCertificationValue(e.target.files, uploadFile);
        }
        else {
            resizeFile(uploadFile).then((result) => {
                setCertificationValue(e.target.files, result);
            })
        }
    }

    const resizeFile = (file) => new Promise(resolve => {
        Resizer.imageFileResizer(file, 2048, 2048, 'JPEG', 50, 0,
        uri => {
          resolve(uri);
        }, 'file' );
    });
    
    return (    
    <>
        <li className="form-check list-group-item">
            <input className="form-check-input me-2 ms-1" type="checkbox" value={checkedState} onChange={(e)=>{ onChange(e.target.checked, certification.id)}} id={'cbx-' + label} />
            <label className="form-check-label px-0" htmlFor={'cbx-' + label}>{name}</label>
            {
                checkedState && 
                <>
                <div className="card p-3 text-dark bg-light">
                    {
                        allowNameEdit &&
                            <InputField placeholder={' '} label={t('Name')} name={`certification.${index}.name`} type='text'/>
                    }
                    <CertificationUploadField name={`certification.${index}.fileList`} handleUpload={handleUpload} />
                    {certification.expires && (
                        <InputField type={'date'} name={`certification.${index}.expiration`} label={t('Expiration Date') + '*'} onChange={ (e) => { } } />
                    )}
                </div>
                </>
            }
        </li>

    </>
    );
}

export default CertificateField;